import { Component, OnInit, forwardRef, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, UntypedFormControl } from '@angular/forms';
import { WeightageModel } from '../utilities/models/weightage-model';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { FunctionsService } from '../utilities/services/functions.service';
import { MatLegacySliderChange as MatSliderChange } from '@angular/material/legacy-slider';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PopupComponent } from './popup/popup.component';
import { slide } from '@app/system/animations/slide.animate';

@Component({
	selector: 'app-weightage',
	templateUrl: './weightage.component.html',
	styleUrls: ['./weightage.component.scss'],
	providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => WeightageComponent), multi: true }],
	animations: [slide]
})
export class WeightageComponent implements OnInit, ControlValueAccessor, OnChanges {

	/**
	 * @desc Angular Input Decorator - Common Parameters
	 * @param object field - file upload field data.
	 * @param formControl control - file upload control.
	 */
	@Input() field: WeightageModel;
	@Input() control: UntypedFormControl;
	@Output() removed = new EventEmitter();
	@Output() weightageTriggered = new EventEmitter();

	progress = '0';
	closeTemplate = false;
	timeout;
	patchTimeout;
	opened = false;
	expected = '0';
	value: number;

	constructor(
		public controlFunctions: FunctionsService,
		public gfService: GlobalFunctionService,
		private popup: MatDialog
	) { }

	ngOnInit(): void {

	}

	ngOnChanges(changes) {
		if (changes && changes.hasOwnProperty('field') && changes.field.currentValue) {
			const field = changes.field.currentValue;
			let weightage: any = field.additionalMetaData.maxWeightage;
			let sliderValue = field.additionalMetaData.defaultWeightage;
			if (Array.isArray(field.additionalMetaData.maxWeightage)) {
				if (field.additionalMetaData.maxWeightage.length) {
					weightage = field.additionalMetaData.maxWeightage.length - 1;
				}
			}
			if (!([null, undefined].includes(field.value))) {
				const value: any = field.value;
				this.value = Number(JSON.stringify(JSON.parse(value)));
				sliderValue = this.value;
				if (Array.isArray(field.additionalMetaData.maxWeightage) && field.additionalMetaData.maxWeightage.length) {
					sliderValue = this.processData('general', sliderValue);
					if (!sliderValue) {
						this.value = 0;
					}
				}
			} else if (!([null, undefined].includes(field.additionalMetaData.defaultWeightage))) {
				this.value = field.additionalMetaData.defaultWeightage;
			}
			this.progress = ((sliderValue / weightage) * 100).toFixed(2);
			if (!([null, undefined].includes(field.additionalMetaData.defaultWeightage)) && [null, undefined].includes(field.value)) {
				this.control.patchValue(Number(this.progress), { emitEvent: false });
			}
			if (!([null, undefined, 0].includes(field.additionalMetaData.expectedWeightage))) {
				let expected = field.additionalMetaData.expectedWeightage;
				if (Array.isArray(field.additionalMetaData.maxWeightage) && field.additionalMetaData.maxWeightage.length) {
					expected = this.processData('expected', expected);
					// if (!([null, undefined].includes(this.field.additionalMetaData.maxWeightage[expected].weightage))) {
					// 	expected = this.field.additionalMetaData.maxWeightage[expected].weightage;
					// }
				}
				this.expected = ((expected / weightage) * 100).toFixed(2);
			}
		}
	}

	remove(data) {
		this.removed.emit(data);
	}

	triggered() {
		this.weightageTriggered.emit(true);
	}

	processData(type: 'general' | 'expected' = 'general', sliderValue) {
		if (Array.isArray(this.field.additionalMetaData.maxWeightage) && this.field.additionalMetaData.maxWeightage.length) {
			const weightageData: any = this.field.additionalMetaData.maxWeightage.filter(items => items.key !== null);
			const individualPercentage = 100 / weightageData.length;
			weightageData.map((resp, index) => {
				resp.percentage = individualPercentage * (index + 1);
			});
			var closest = this.closestValue(weightageData, sliderValue);
			if (closest) {
				weightageData.map((data, index) => {
					if (data.percentage === closest) {
						sliderValue = index + 1;
					}
				});
				if (type === 'general' && weightageData[sliderValue - 1]) {
					this.value = weightageData[sliderValue - 1].weightage;
				}
				if (!([null, undefined].includes(this.field.additionalMetaData.maxWeightage[sliderValue].weightage))) {
					sliderValue = this.field.additionalMetaData.maxWeightage[sliderValue].weightage;
				}
			} else {
				sliderValue = 0;
			}
		}
		return sliderValue;
	}

	closestValue(data, value) {
		const actualData = [...data];
		actualData.unshift({
			percentage: 0
		});
		return actualData.reduce(function (prev, curr) {
			let prevValue = prev;
			let currentValue = curr;
			if (prevValue.hasOwnProperty('percentage')) {
				prevValue = prevValue.percentage;
			}
			if (currentValue.hasOwnProperty('percentage')) {
				currentValue = currentValue.percentage;
			}
			return (Math.abs(currentValue - value) < Math.abs(prevValue - value) ? currentValue : prevValue);
		});
	}

	sliderChange(event: MatSliderChange) {
		let weightage: any = this.field.additionalMetaData.maxWeightage;
		let sliderValue = event.value;
		if (Array.isArray(this.field.additionalMetaData.maxWeightage) && this.field.additionalMetaData.maxWeightage.length) {
			weightage = this.field.additionalMetaData.maxWeightage.length - 1;
			if (!([null, undefined].includes(this.field.additionalMetaData.maxWeightage[event.value].weightage))) {
				sliderValue = this.field.additionalMetaData.maxWeightage[event.value].weightage;
				// weightage = this.field.additionalMetaData.maxWeightage.length; // should enable this for without none option
			}
		}
		this.progress = ((sliderValue / weightage) * 100).toFixed(2);
		if (this.patchTimeout) {
			clearTimeout(this.patchTimeout);
		}
		this.timeoutManage();
		// this.patchTimeout = setTimeout(() => {
		if ([null, undefined].includes(this.control.value) || this.control.value !== this.value) {
			// if (Array.isArray(this.field.additionalMetaData.maxWeightage) && this.field.additionalMetaData.maxWeightage.length) {
			// 	this.control.patchValue(this.field.additionalMetaData.maxWeightage[this.value].key);
			// } else {
			// 	this.control.patchValue(this.value);
			// }
			this.control.patchValue(Number(this.progress));
		}
		// }, 2000);
	}

	sliderInputChange(event: MatSelectChange) {
		this.value = event.value;
		if (this.field.additionalMetaData.hasOwnProperty('minWeightage') && this.field.additionalMetaData.minWeightage >= event.value) {
			event.source.value = this.field.additionalMetaData.minWeightage;
		}
		clearTimeout(this.timeout);
	}

	focusSlider() {
		clearTimeout(this.timeout);
	}

	isOpen(status) {
		this.opened = status;
		// this.closeTemplate = status;
		if (status) {
			this.timeoutManage();
		} else {
			clearTimeout(this.timeout);
		}
	}

	leaveSlider() {
		if (this.opened) {
			clearTimeout(this.timeout);
			this.timeoutManage();
		}
	}

	timeoutManage() {
		this.closeTemplate = false;
		this.timeout = setTimeout(() => {
			this.closeTemplate = true;
		}, 3000);
	}

	showHelp() {
		if (this.field.additionalMetaData.showHelp) {
			this.closeTemplate = true;
			const dialogRef = this.popup.open(PopupComponent, {
				panelClass: ['custom-panel'],
				// height: 'auto',
				// width: 'auto',
				// maxWidth: 'auto',
				data: {
					action: 'skillLevelDesc',
					popup: true,
					helpData: this.field.additionalMetaData.maxWeightage
				},
				disableClose: true,
				maxWidth: '860px',
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(async (result) => {
				if (result) {
				}
			});
		}
	}

	writeValue(value: null) { }

	registerOnChange(fn: () => void) { }

	registerOnTouched(fn: () => void) { }

}
